import { defineEvent } from '../types/event';
export var COUPON_FAB_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
